import {
  recoverServiceabilityField,
  errorMock,
  BACKUP_OFFER_KEY,
  PLACE_ID,
  IProduct,
  IProductOfferListByTech,
  checkIsApp,
  START_PRODUCT_HUB,
  ICoverageToolFlowType,
} from '@vfit/consumer/data-access';
import { API, TechTypes } from '@vfit/shared/data-access';
import { useMutation } from 'react-query';
import { CustomOptions, INextError, LoggerInstance, nextClient } from '@vfit/shared/data-access';
import {
  IBackupOffer,
  ICharacteristic,
  IOfferingServiceabilityRequest,
  IOfferingServiceabilityResponse,
  IValidAddressList,
} from '@vfit/shared/models';

const offeringServiceabilityService = (
  payload: IOfferingServiceabilityRequest,
  customOptions?: CustomOptions
): Promise<IOfferingServiceabilityResponse> =>
  nextClient.post(API.OFFERING_SERVICEABILITY, payload, {
    ...(customOptions?.headers && { headers: customOptions.headers }),
    ...(customOptions?.silentLoginHeaders && {
      silentLoginHeaders: customOptions.silentLoginHeaders,
    }),
  });

const onSuccessServiceAbilityIbuy = (
  offerId: string,
  data: IOfferingServiceabilityResponse,
  allProducts: IProduct[],
  alternativeCmsIdList?: string[],
  alternativeCmsIdListByTech?: IProductOfferListByTech[],
  place_id?: string
) => {
  if (place_id) localStorage.setItem(PLACE_ID, place_id);

  const originalTechType: TechTypes = recoverServiceabilityField(
    data?.serviceabilityCharacteristic || [],
    'Technology'
  ) as TechTypes;

  const idByTech = alternativeCmsIdListByTech?.filter(
    (el) => el?.technology.toLowerCase() === originalTechType?.toLowerCase()
  );
  const allLockinProducts = allProducts?.filter((el) => el?.isLockInProduct);
  const lockinIds = allLockinProducts?.map((el) => el?.cmsId);

  const alternativeProductList: { cmsId: string; offerId: string }[] = [];
  const alternativeOffersList: string[] = [];

  alternativeCmsIdList?.forEach((alternativeCmsId) => {
    const foundedProd = allProducts?.find(
      (el) => el?.cmsId == alternativeCmsId && (checkIsApp() || !el?.isLockInProduct)
    );
    if (foundedProd?.offerId) {
      alternativeProductList.push({
        cmsId: foundedProd?.cmsId?.toString(),
        offerId: foundedProd?.offerId?.toString(),
      });
      alternativeOffersList.push(foundedProd?.offerId?.toString());
    }
  });

  const isTechFWA: boolean = originalTechType?.toLowerCase().includes('fwa');
  const isOutdoor: boolean = isTechFWA
    ? originalTechType?.toLowerCase().includes('outdoor')
    : false;
  localStorage.setItem('isTechFWA', JSON.stringify(isTechFWA));
  localStorage.setItem('isOutdoor', JSON.stringify(isOutdoor));
  localStorage.setItem('techOffer', JSON.stringify(originalTechType));

  if (idByTech?.length > 0 && (checkIsApp() || !lockinIds?.includes(idByTech?.[0]?.id))) {
    const findByTechCms = allProducts?.find((el) => el?.cmsId === idByTech?.[0]?.id);
    const foundedOffer = data?.offeringServiceabilityItem.find(
      (offer: IBackupOffer) => offer?.offering?.id === findByTechCms?.offerId?.toString()
    );
    localStorage.setItem('offeringServiceability', JSON.stringify(data));
    localStorage.setItem(
      BACKUP_OFFER_KEY,
      JSON.stringify({
        offeringId: foundedOffer?.offering?.id,
        cmsId:
          alternativeProductList?.find?.((el) => el?.offerId == foundedOffer?.offering?.id)
            ?.cmsId || '',
      })
    );

    const startProductTechOverrideHub = window?.location?.href;
    localStorage.setItem(START_PRODUCT_HUB, startProductTechOverrideHub);
  } else {
    let foundedOffer = data?.offeringServiceabilityItem?.find(
      (offer: IBackupOffer) => offer?.offering?.id === offerId
    );

    // alternative product
    if (!foundedOffer && alternativeOffersList?.length > 0) {
      alternativeOffersList?.forEach((aOL) => {
        const foundedAmdOffer = (
          data as IOfferingServiceabilityResponse
        )?.offeringServiceabilityItem?.find(
          (backupOffer: IBackupOffer) => aOL?.toString() === backupOffer?.offering?.id?.toString()
        );
        if (foundedAmdOffer && !foundedOffer) foundedOffer = foundedAmdOffer;
      });
    }
    const unserviceableCharacteristic = data?.serviceabilityCharacteristic?.filter(
      (characteristic: ICharacteristic) =>
        characteristic.displayName === 'DisplayTechnologyName' &&
        characteristic.displayValue === '3G 4G'
    );

    if (foundedOffer && !unserviceableCharacteristic[0]) {
      localStorage.setItem('offeringServiceability', JSON.stringify(data));
      localStorage.setItem(
        BACKUP_OFFER_KEY,
        JSON.stringify({
          offeringId: foundedOffer?.offering?.id,
          cmsId:
            alternativeProductList?.find?.((el) => el?.offerId === foundedOffer?.offering?.id)
              ?.cmsId || '',
        })
      );
    }
  }
};

export const useServiceabilityAddressMutation = (
  coverageType: ICoverageToolFlowType,
  offerId: string,
  allProducts: IProduct[],
  alternativeCmsIdList?: string[],
  alternativeCmsIdListByTech?: IProductOfferListByTech[],
  place_id?: string
) => {
  return useMutation(
    'offeringServiceability',
    (validatedAddress: IValidAddressList) =>
      offeringServiceabilityService({
        ...(coverageType != 'FASTWEB' && {
          doFetchFastWebTechnologyFlag: coverageType === 'AMDOCS_FW',
        }),
        serviceabilityAddress: validatedAddress,
      }),
    {
      onSuccess: (data: IOfferingServiceabilityResponse) => {
        localStorage.setItem('offeringServiceability', JSON.stringify(data));
        onSuccessServiceAbilityIbuy(
          offerId,
          data,
          allProducts,
          alternativeCmsIdList,
          alternativeCmsIdListByTech,
          place_id
        );
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR - offeringServiceability: `, error);
        localStorage.setItem(
          `offeringServiceability`,
          JSON.stringify(errorMock(`offeringServiceability`))
        );
      },
    }
  );
};
